import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { EmailInput } from '@telialt/common-email-input/src';

import { LEAD_TEST_IDS } from '../constants';
import { LeadFieldName } from '../model';

type Props = { initialValue?: string };

export const EmailAddressField: FC<Props> = ({ initialValue = '' }) => {
    const { t } = useTranslations();

    return (
        <EmailInput
            label={t['content.lead.email.label']}
            defaultValue={initialValue}
            showValidIcon={true}
            name={'emailAddress' as LeadFieldName}
            dataTest={LEAD_TEST_IDS.FIELD_EMAIL}
        />
    );
};
